import React, { Component } from 'react';
import metadata from './toolkit_metadata.json';

function CommunityComponent(props) {
    let fraq = props.freq / props.totalFreq;

    var formattedDescription = props.desc;

    return <div className="community" style={{'opacity': Math.min(1, 0.1 + (2.0 * (props.freq / props.maxFreq)))}}>
        <div className="left">
            <div className="name">{props.name}</div>
            <div className="desc">{formattedDescription}</div>
        </div>
        <div className="right">
            <div className="fraq" style={{width: Math.round(fraq * 100) + "%"}}><span>{Math.round(fraq * 100)}%</span></div>
        </div>
    </div>;
}

function UserComponent(props) {
    let communities = props.communities.split(";").map((c) => c.split(":"));
    communities.sort((a, b) => b[1] - a[1]);
    let totalFreq = communities.reduce((total, c) => total + parseFloat(c[1]), 0);
    let maxFreq = communities.reduce((total, c) => Math.max(total, parseFloat(c[1])), 0);

    return <div className="user">
        <div className="community-header">
            <div>Community name</div>
            <div><div style={{textAlign: 'left'}}>0%</div><div>User activity</div><div style={{textAlign: 'right'}}>100%</div></div>
        </div>
        {communities.map((c, i) => {
            let name = c[0];
            let freq = c[1];

            return <CommunityComponent key={i} name={name} desc={metadata[name] ? metadata[name]["description"] : null} freq={freq} totalFreq={totalFreq} maxFreq={maxFreq} />;
        })}
    </div>;
}

export default UserComponent;


// WEBPACK FOOTER //
// ./src/UserComponent.js